var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD65A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B139",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-/-Fan-user",
    transform: "translate(-58.000000, -921.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "earn-more",
    transform: "translate(0.000000, 788.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4584688,107 L58.5419375,107 C58.2425312,107 58,107.223875 58,107.499875 L58,118.500125 C58,118.776125 58.2425312,119 58.5419375,119 L64.90625,119 L64.90625,114.5 L63.28125,114.5 L63.28125,112.625 L64.90625,112.625 L64.90625,111.125 C64.90625,109.575125 65.9694063,108.812375 67.46725,108.812375 C68.1846875,108.812375 68.801375,108.861875 68.9809375,108.883625 L68.9809375,110.503625 L67.9421562,110.504 C67.127625,110.504 66.9375,110.861375 66.9375,111.385625 L66.9375,112.625 L68.96875,112.625 L68.5625,114.5 L66.9375,114.5 L66.97,119 L70.4584688,119 C70.7574688,119 71,118.776125 71,118.500125 L71,107.499875 C71,107.223875 70.7574688,107 70.4584688,107",
    id: "Fill-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.2b4c680dcb6c6631fdd3ff225300c101.svg";
export { ForwardRef as ReactComponent };